import ky from 'ky';
import { getSetting } from '../helpers/tools.js';

const api = ky.create({
  prefixUrl: getSetting('URL_SSO'),
  timeout: 30000,
  credentials: 'include',
});

export default api;
